import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initWebVitals } from './lib/performance'

// Initialize performance monitoring (Web Vitals)
initWebVitals();

// NOTE: StrictMode disabled to prevent Supabase storage contention
// StrictMode causes double-mounting in dev which leads to multiple
// simultaneous getSession() calls competing for localStorage locks
// TODO: Re-enable StrictMode after implementing session caching
createRoot(document.getElementById('root')!).render(
  <App />
)
